function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Maps",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-Landing---map-closeup---offline-w/signals",
  transform: "translate(-646.000000, -198.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "GREY",
  transform: "translate(646.000000, 198.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#8C8C8C",
  cx: 13,
  cy: 13,
  r: 13
}), /*#__PURE__*/React.createElement("g", {
  id: "cloud-outlined",
  transform: "translate(3.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.978491,4.56768382 C15.0257025,2.06582108 12.597964,0.286764706 9.75416065,0.286764706 C6.91035731,0.286764706 4.48261883,2.06375 3.52983029,4.56561275 C1.74699235,5.03160539 0.430147059,6.64704657 0.430147059,8.57107843 C0.430147059,10.8596201 2.29203732,12.7132353 4.58871537,12.7132353 L14.9112846,12.7132353 C17.2079627,12.7132353 19.0698529,10.8596201 19.0698529,8.57107843 C19.0698529,6.65118873 17.7571683,5.03574755 15.978491,4.56768382 Z M16.7336487,10.3874142 C16.2514432,10.8702837 15.5952206,11.141003 14.9112846,11.1392245 L4.58871537,11.1392245 C3.90012802,11.1392245 3.25314716,10.8720466 2.76635127,10.3874142 C2.28126442,9.906545 2.00937566,9.25258719 2.01118448,8.57107843 C2.01118448,7.99117647 2.20050305,7.44648284 2.55623851,6.99084559 C2.9046037,6.54945561 3.38694347,6.23198863 3.93133288,6.08578431 L4.7197758,5.88074755 L5.00894088,5.12273284 C5.18784877,4.65052696 5.43748769,4.20938725 5.75161666,3.80966912 C6.06173421,3.41348778 6.42908342,3.06521954 6.8417066,2.77620098 C7.6967199,2.17765931 8.70359687,1.86078431 9.75416065,1.86078431 C10.8047244,1.86078431 11.8116014,2.17765931 12.6666147,2.77620098 C13.0805992,3.06615196 13.4467363,3.41409314 13.7567046,3.80966912 C14.0708336,4.20938725 14.3204725,4.65259804 14.4993804,5.12273284 L14.7864652,5.87867647 L15.5728278,6.08578431 C16.7024439,6.38609069 17.4888065,7.40713235 17.4888065,8.57107843 C17.4888065,9.25660539 17.2204446,9.90278186 16.7336487,10.3874142 L16.7336487,10.3874142 Z",
  id: "Shape"
})))));

var SvgOfflinePin = function SvgOfflinePin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfflinePin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offline-pin.33793a06.svg";
export { ForwardRef as ReactComponent };